import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  getCustomer,
  getCustomerSingleAccounts,
  getCustomerTransactions,
  getflashTransactions,
  totalSpentByCustomerPerMonth,
  suspendAccount,
  closeAccount,
  getLoanSummary,
  getNormaLoanDetails,
  getEmergencyLoanDetails,
  getDevelopmentLoanDetails,
  getJijengeLoanDetails,
  manualTransaction,
  sharesManualTransaction,
  uploadFile,
} from "../../sdk/customers/customers";
import { generateAdminAccountStatement } from "../../sdk/statements/statement";
import Calendar from "../../components/calendar/Calendar";
import TransactionModal from "../../components/Modals/transactions/TransactionModal";
import { addLoanPaymentManually } from "../../sdk/loans/loans";
import LoanAddTransactions from "../../components/Modals/transactions/loanAddTransactions";
import ViewReceipt from "../../components/Modals/transactions/viewReceipt";
import SuspensionReason from "../../components/Modals/suspend-account/SuspensionReason";
import ContinueSuspendAcc from "../../components/Modals/suspend-account/ContinueSuspendAcc";
import ContinueCloseAcc from "../../components/Modals/closeAccount/ContinueCloseAcc";
import ClosureReason from "../../components/Modals/closeAccount/ClosureReason";
import UploadDocument from "../../components/Modals/closeAccount/UploadDocument";
import ClosureImplications from "../../components/Modals/closeAccount/ClosureImplications";
import DocumentReason from "../../components/Modals/suspend-account/DocumentReason";
import SuspensionImplications from "../../components/Modals/suspend-account/SuspensionImplications";
import ReviewSuspension from "../../components/Modals/suspend-account/ReviewSuspension";
import FinishClosure from "../../components/Modals/closeAccount/FinishClosure";
import SuspendAccount from "../../components/Modals/suspend-account/SuspendAccount";
import AddTransactionSavings from "../../components/Modals/transactions/addTransactionSavings";
import SharesAddTransaction from "../../components/Modals/transactions/sharesAddTransactions";
import LoadingButtons from "../../components/Modals/edit-customer/LoadingButtons";
import PaymentAddedSuccessfully from "../../components/Modals/transactions/paymentAddedSuccessfully";
import CloseAccount from "../../components/Modals/closeAccount/CloseAccount";
import { Dropdown } from "antd";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDown, X } from "lucide-react";
import Loading from "../../components/loaders/Loading";
import { toast } from "react-toastify";
import { capitalize } from "@patternfly/react-core";
import { PERMISSIONS } from "../../contexts/permissions";
import { PermissionGate } from "../../helpers/PermissionGate";
import StatementSuccess from "../../components/success-modals/StatementSuccess";

const CustomerTransactions = () => {
  const { id, accountId } = useParams();
  const [singleAccount, setSingleAccount] = useState({});

  const [transactions, setTransactions] = useState([]);
  const [flashTrans, setFlashTrans] = useState([]);

  const [customer, setCustomer] = useState({});

  const [isLoadingButtons, setIsLoadingButtons] = useState(false);

  const [spending, setSpending] = useState(null);
  const navigate = useNavigate();
  const { state } = useLocation();

  const [singleTransaction, setSingleTransaction] = useState({});

  const [flashLoan, setFlashLoan] = useState([]);

  const [normalLoan, setNormalLoan] = useState([]);
  const [emergencyLoan, setEmergencyLoan] = useState([]);
  const [developmentLoan, setDevelopmentLoan] = useState([]);

  console.log("developmentLoan", developmentLoan);

  const [jijengeLoan, setJijengeLoan] = useState([]);

  const fetchCustomer = async (id) => {
    const res = await getCustomer(id);
    setCustomer(res?.data);
  };

  const fetchSpendingPerMonth = async (state) => {
    const res = await totalSpentByCustomerPerMonth(state.account_number);
    setSpending(res.data);
  };

  const fetchSingleAccount = async (custId, id) => {
    const res = await getCustomerSingleAccounts(id, custId);
    setSingleAccount(res?.data);
  };

  const fetchLoanSummary = async (customer) => {
    const mobile = customer?.mobileno?.includes("+")
      ? customer?.mobileno?.split("+")[1]
      : customer?.mobileno;

    const res = await getLoanSummary(mobile);
    setFlashLoan(res);
  };

  const fetchNormaLoan = async (customer) => {
    const mobile = customer?.mobileno?.includes("+")
      ? customer?.mobileno?.split("+")[1]
      : customer?.mobileno;
    const res = await getNormaLoanDetails(mobile);
    setNormalLoan(res);
  };

  const fetchEmergencyLoan = async (customer) => {
    const mobile = customer?.mobileno?.includes("+")
      ? customer?.mobileno?.split("+")[1]
      : customer?.mobileno;
    const res = await getEmergencyLoanDetails(mobile);
    setEmergencyLoan(res);
  };

  const fetchDevelopmentLoan = async (customer) => {
    const mobile = customer?.mobileno?.includes("+")
      ? customer?.mobileno?.split("+")[1]
      : customer?.mobileno;
    const res = await getDevelopmentLoanDetails(mobile);
    setDevelopmentLoan(res);
  };

  const fetchJijengeLoan = async (customer) => {
    const mobile = customer?.mobileno?.includes("+")
      ? customer?.mobileno?.split("+")[1]
      : customer?.mobileno;
    const res = await getJijengeLoanDetails(mobile);
    setJijengeLoan(res);
  };

  useEffect(() => {
    fetchLoanSummary(customer);
    fetchNormaLoan(customer);
    fetchEmergencyLoan(customer);
    fetchDevelopmentLoan(customer);
    fetchJijengeLoan(customer);
  }, [customer]);

  const fetchTransactions = async (state) => {
    const res = await getCustomerTransactions(state?.account_number);
    setTransactions(res?.data);
  };

  const fetchFlashTransactions = async (id, state) => {
    try {
      const res = await getflashTransactions(
        id,
        state?.prod_ID,
        state?.loan_code,
      );
      setFlashTrans(res);
    } catch (error) {
      console?.error("Error fetching emergency transactions:", error);
    }
  };

  useEffect(() => {
    fetchCustomer(id);
    fetchSingleAccount(id, accountId);
    fetchTransactions(state);
    fetchFlashTransactions(id, state);
    fetchSpendingPerMonth(state);
  }, [id, accountId, state]);

  const [showBalance, setShowBalance] = useState(false);

  const toggleBalanceVisibility = () => {
    setShowBalance(!showBalance);
  };

  const handleBack = () => {
    navigate(-1);
  };

  const [openTransaction, setOpenTransaction] = useState(false);

  const openTransactionModal = (transaction) => {
    setSingleTransaction(transaction);
    setOpenTransaction(true);
  };

  const closeTransactionModal = () => {
    setOpenTransaction(false);
  };

  const [viewReceiptOpen, setViewReceiptOpen] = useState(false);

  const openViewReceipt = () => {
    setViewReceiptOpen(true);
    closeTransactionModal();
  };

  const closeViewReceipt = () => {
    setViewReceiptOpen(false);
  };

  const [selectedOption, setSelectedOption] = useState("");
  const [suspendReasonOpen, setSuspendReasonOpen] = useState(false);

  const handleCloseSuspendReason = () => {
    setSuspendReasonOpen(false);
  };

  const handleOpenSuspendReason = () => {
    setSuspendReasonOpen(true);
  };

  const [selectedReason, setSelectedReason] = useState("");
  const [closureReasonOpen, setClosureReasonOpen] = useState(false);
  const handleCloseClosureReason = () => {
    setClosureReasonOpen(false);
  };

  const handleOpenClosureReason = () => {
    setClosureReasonOpen(true);
  };

  const [note, setNote] = useState("");
  const [documentReasonOpen, setDocumentReasonOpen] = useState(false);

  const handleCloseDocumentReason = () => {
    setDocumentReasonOpen(false);
  };

  const handleOpenDocumentReason = () => {
    setDocumentReasonOpen(true);
  };

  const [reason, setReason] = useState("");
  const [uploadDocumentOpen, setUploadDocumentOpen] = useState(false);
  const handleCloseUploadDocument = () => {
    setUploadDocumentOpen(false);
  };
  const handleOpenUploadDocument = () => {
    setUploadDocumentOpen(true);
  };

  const [toggleState, setToggleState] = useState("Yes");
  const [activeTab, setActiveTab] = useState("Yes");
  const [suspensionImplicationsOpen, setSuspensionImplicationsOpen] =
    useState(false);

  const handleCloseSuspensionImplications = () => {
    setSuspensionImplicationsOpen(false);
  };

  const handleOpenSuspensionImplications = () => {
    setSuspensionImplicationsOpen(true);
  };
  const [confirmationStatus, setConfirmationStatus] = useState("Yes");
  const [selectedTab, setSelectedTab] = useState("Yes");
  const [closureImplicationsOpen, setClosureImplicationsOpen] = useState(false);
  const handleCloseClosureImplications = () => {
    setClosureImplicationsOpen(false);
  };

  const handleOpenClosureImplications = () => {
    setClosureImplicationsOpen(true);
  };

  const [reviewSuspensionOpen, setReviewSuspensionOpen] = useState(false);

  const handleCloseReviewSuspension = () => {
    setReviewSuspensionOpen(false);
  };

  const handleOpenReviewSuspension = () => {
    setReviewSuspensionOpen(true);
  };

  const [finishClosureOpen, setFinishClosureOpen] = useState(false);

  const handleCloseFinishClosure = () => {
    setFinishClosureOpen(false);
  };

  const handleOpenFinishClosure = () => {
    setFinishClosureOpen(true);
  };

  const [isSuspendAccountModalOpen, setIsSuspendAccountModalOpen] =
    useState(false);

  const closeSuspendAccount = () => {
    setIsSuspendAccountModalOpen(false);
  };

  const [isCloseAccountModalOpen, setIsCloseAccountModalOpen] = useState(false);
  const closeCloseAccount = () => {
    setIsCloseAccountModalOpen(false);
  };

  const [isContinueSuspendAccModalOpen, setIsContinueSuspendAccModalOpen] =
    useState(false);

  const openContinueSuspendAcc = () => {
    setIsContinueSuspendAccModalOpen(true);
  };

  const closeContinueSuspendAcc = () => {
    setIsContinueSuspendAccModalOpen(false);
  };

  const [transMode, setTransMode] = useState("MPESA");
  const [amount, setAmount] = useState("");
  const [date, setDate] = useState(null);
  const [accNumber, setAccNumber] = useState("");
  const [refNumber, setRefNumber] = useState("");
  const [docFile, setDocFile] = useState(null);
  const [savingsChecked, setSavingsChecked] = useState(false);

  const [sharesTransMode, setSharesTransMode] = useState("MPESA");
  const [sharesAmount, setSharesAmount] = useState("");
  const [sharesDate, setSharesDate] = useState(null);
  const [sharesAccNumber, setSharesAccNumber] = useState("");
  const [sharesRefNumber, setSharesRefNumber] = useState("");
  const [sharesDocFile, setSharesDocFile] = useState(null);
  const [isChecked, setIsChecked] = useState(false);

  const [isContinueCloseAccModalOpen, setIsContinueCloseAccModalOpen] =
    useState(false);

  const closeContinueCloseAcc = () => {
    setIsContinueCloseAccModalOpen(false);
  };

  const OpenContinueCloseAcc = () => {
    setIsContinueCloseAccModalOpen(true);
  };

  const handleSuspendAccount = async () => {
    const payload = {
      accountId: singleAccount?.id,
      userId: customer?.id,
      action: "suspend",
      reason: selectedOption,
      additionalDetails: note,
      disableOnlineAndMobileAccess: toggleState === "Yes" ? true : false,
      freezeTransactions: activeTab === "Yes" ? true : false,
      // attachments: [

      // ],
    };

    try {
      await suspendAccount(payload);
      toast?.success("Account successfully suspended!");
      fetchSingleAccount(id, accountId);
      closeSuspendAccount();
    } catch (error) {
      toast?.error(error?.message || "Error suspending account:", error);
    }
  };

  const handleCloseAccount = async () => {
    const payload = {
      accountId: singleAccount?.id,
      userId: customer?.id,
      action: "close",
      reason: selectedReason,
      additionalDetails: reason,
      disableOnlineAndMobileAccess: confirmationStatus === "Yes" ? true : false,
      freezeTransactions: selectedTab === "Yes" ? true : false,
      // attachments: [

      // ],
    };
    try {
      await closeAccount(payload);
      toast?.success("Account successfully closed!");
      fetchSingleAccount(id, accountId);
      closeCloseAccount();
    } catch (error) {
      toast?.error(error?.message || "Error closing account:", error);
    }
  };

  const [isAddTransactionSavingsOpen, setIsAddTransactionSavingsOpen] =
    useState(false);

  const openAddTransactionSavingsOpen = () => {
    setIsAddTransactionSavingsOpen(true);
  };

  const closeAddTransactionSavingsOpen = () => {
    setIsAddTransactionSavingsOpen(false);
  };

  const [isSharesAddTransactionOpen, setIsSharesAddTransactionOpen] =
    useState(false);

  const openSharesAddTransactionOpen = () => {
    setIsSharesAddTransactionOpen(true);
  };

  const closeSharesAddTransactionOpen = () => {
    setIsSharesAddTransactionOpen(false);
  };

  const [isPaymentAddedSuccessfullyOpen, setIsPaymentAddedSuccessfullyOpen] =
    useState(false);

  const closePaymentAddedSuccessfully = () => {
    setIsPaymentAddedSuccessfullyOpen(false);
  };

  const handleManualTransaction = async () => {
    setIsAddTransactionSavingsOpen(false);
    setIsLoadingButtons(true);
    try {
      let documentUrl = null;
      const sanitizeFileName = (file) => {
        const sanitizedName = file?.name?.replace(/\s+/g, "-"); // replace spaces with -
        return new File([file], sanitizedName, { type: file?.type });
      };

      // Upload the document file first (if present)
      if (docFile) {
        try {
          const sanitizedFile = sanitizeFileName(docFile);
          documentUrl = await uploadFile(sanitizedFile);
        } catch (uploadError) {
          setIsLoadingButtons(false);
          toast?.error(
            uploadError?.message || "Error uploading document",
            uploadError,
          );
          return;
        }
      }

      await manualTransaction({
        deposit_method: transMode,
        type: "credit",
        amount: amount,
        customer_id: id,
        account_id: singleAccount?.id,
        currency_id: "KES",
        ref_number: refNumber,
        withdrawal_method: "none",
        phone_number: accNumber,
        document_url: documentUrl,
        transaction_date: date,
      });

      setIsLoadingButtons(false);
      fetchSingleAccount(id, accountId);
      setIsPaymentAddedSuccessfullyOpen(true);

      fetchTransactions(state);

      // setTransMode("");
      setAmount("");
      setRefNumber("");
      setAccNumber("");
      setDocFile(null);
      setDate("");
      setSavingsChecked(false);

      setTimeout(() => {
        setIsPaymentAddedSuccessfullyOpen(false);
      }, 1000);
    } catch (error) {
      setIsLoadingButtons(false);
      toast?.error(error?.message || "Error adding manual transaction", error);
    }
  };

  const handleSharesManualTransaction = async () => {
    setIsSharesAddTransactionOpen(false);
    setIsLoadingButtons(true);
    try {
      let documentUrl = null;
      const sanitizeFileName = (file) => {
        const sanitizedName = file?.name?.replace(/\s+/g, "-"); // replace spaces with -
        return new File([file], sanitizedName, { type: file?.type });
      };

      // Upload the document file first (if present)
      if (sharesDocFile) {
        try {
          const sanitizedFile = sanitizeFileName(sharesDocFile);
          documentUrl = await uploadFile(sanitizedFile);
        } catch (uploadError) {
          setIsLoadingButtons(false);
          toast?.error(
            uploadError?.message || "Error uploading document",
            uploadError,
          );
          return;
        }
      }

      //

      await sharesManualTransaction({
        deposit_method: sharesTransMode,
        type: "credit",
        amount: sharesAmount,
        customer_id: id,
        account_id: singleAccount?.id,
        currency_id: "KES",
        ref_number: sharesRefNumber,
        withdrawal_method: "none",
        phone_number: sharesAccNumber,
        document_url: documentUrl,
        transaction_date: sharesDate,
      });

      setIsLoadingButtons(false);
      fetchSingleAccount(id, accountId);
      setIsPaymentAddedSuccessfullyOpen(true);

      fetchTransactions(state);

      // setSharesTransMode("");
      setSharesAmount("");
      setSharesRefNumber("");
      setSharesAccNumber("");
      setSharesDate("");
      setSharesDocFile(null);
      setIsChecked(false);

      setTimeout(() => {
        setIsPaymentAddedSuccessfullyOpen(false);
      }, 1000);
    } catch (error) {
      setIsLoadingButtons(false);
      toast?.error(error?.message || "Error adding manual transaction", error);
    }
  };

  const [loanTransMode, setLoanTransMode] = useState("MPESA");
  const [loanAmount, setLoanAmount] = useState("");
  const [loanDate, setLoanDate] = useState(null);
  const [loanAccNumber, setLoanAccNumber] = useState("");
  const [loanRefNumber, setLoanRefNumber] = useState("");
  const [loanDocFile, setLoanDocFile] = useState(null);

  const [loansChecked, setLoansChecked] = useState(false);

  const [isLoanAddTransactionsOpen, setIsLoanAddTransactionsOpen] =
    useState(false);

  const openLoanAddTransactionsOpen = () => {
    setIsLoanAddTransactionsOpen(true);
  };

  const closeLoanAddTransactionsOpen = () => {
    setIsLoanAddTransactionsOpen(false);
  };

  const handleManualLoanPayment = async () => {
    setIsLoanAddTransactionsOpen(false);
    setIsLoadingButtons(true);
    try {
      let documentUrl = null;
      const sanitizeFileName = (file) => {
        const sanitizedName = file?.name?.replace(/\s+/g, "-"); // replace spaces with -
        return new File([file], sanitizedName, { type: file?.type });
      };
      // Upload the document file first (if present)
      if (loanDocFile) {
        try {
          const sanitizedFile = sanitizeFileName(loanDocFile);
          documentUrl = await uploadFile(sanitizedFile);
        } catch (uploadError) {
          setIsLoadingButtons(false);
          toast?.error(
            uploadError?.message || "Error uploading document",
            uploadError,
          );
          return;
        }
      }

      await addLoanPaymentManually({
        deposit_method: loanTransMode,
        type: "credit",
        amount: loanAmount,
        customer_id: id,
        account_id: accountId,
        currency_id: "KES",
        ref_number: loanRefNumber,
        withdrawal_method: "none",
        phone_number: loanAccNumber,
        document_url: documentUrl,
        transaction_date: loanDate,
      });

      setIsLoadingButtons(false);
      fetchTransactions(state);
      setIsPaymentAddedSuccessfullyOpen(true);
      fetchFlashTransactions(id, state);
      // fetchSingleLoanUser(customerId, loanCode, loanType);

      // setLoanTransMode("");
      setLoanAmount("");
      setLoanDate("");
      setLoanAccNumber("");
      setLoanRefNumber("");
      setLoanDocFile(null);
      setLoansChecked(false);

      setTimeout(() => {
        setIsPaymentAddedSuccessfullyOpen(false);
      }, 1000);
    } catch (error) {
      setIsLoadingButtons(false);
      toast?.error(error?.message || "Error adding manual transaction", error);
    }
  };

  const [showStatements, setShowStatements] = useState(false);
  const [showStatementSuccess, setShowStatementSuccess] = useState(false);
  const [loadingStatements, setLoadingStatements] = useState(false);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [customerFocusedInput, setCustomerFocusedInput] = useState(null);

  const toggleStatementSuccess = () => {
    setShowStatementSuccess(true);
  };
  const closeStatementSuccess = () => {
    setShowStatementSuccess(false);
  };

  const productName = singleAccount?.product?.name?.toLowerCase() || "";
  const isSharesAccount = productName === "shares";
  const items = isSharesAccount
    ? [
        {
          key: "1",
          label: "Adjust shares",
        },
        {
          key: "2",
          label: (
            <PermissionGate required={[PERMISSIONS?.MB?.VIEW_STATEMENTS]}>
              Statements
            </PermissionGate>
          ),
          onClick: () => setShowStatements(true),
        },
        {
          key: "3",
          label: "Export",
        },
        {
          key: "4",
          label: "Extend purchase period",
        },
      ]
    : [
        {
          key: "2",
          label: (
            <PermissionGate required={[PERMISSIONS?.MB?.VIEW_STATEMENTS]}>
              Statements
            </PermissionGate>
          ),
          onClick: () => setShowStatements(true),
        },
      ];

  const downloadFile = (fileUrl, fileName = "statement.pdf") => {
    const link = document.createElement("a");
    link.href = fileUrl;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  const handleGenerateStatement = async () => {
    if (fromDate === null || toDate === null) {
      toast.error("Enter a valid start date or end date");
      return;
    }
    try {
      setLoadingStatements(true);
      const response = await generateAdminAccountStatement(
        fromDate,
        toDate,
        id,
        accountId,
      );
      if (response.status === 200 || response.status === 201) {
        downloadFile(response.data.url, "Account-statement.pdf");
        setShowStatements(false);
        setLoadingStatements(false);
        toggleStatementSuccess();
      } else {
        toast.error(response?.data?.error?.message);
        setLoadingStatements(false);
      }
    } catch (error) {
      setLoadingStatements(false);
      toast.error(error?.message);
    }
  };

  // Normalize base account status
  const baseStatus = singleAccount?.status?.toLowerCase();

  // Check if loans exist and account is active
  const isActive =
    baseStatus === "active" &&
    normalLoan &&
    flashLoan &&
    emergencyLoan &&
    developmentLoan &&
    jijengeLoan;

  // Determine raw display status
  let displayStatus = singleAccount?.status;

  if (isActive) {
    switch (singleAccount?.product?.name) {
      case "Normal Loan":
        displayStatus = normalLoan?.data?.loan_status || displayStatus;
        break;
      case "Flash Loan":
        displayStatus = flashLoan?.data?.loan_status || displayStatus;
        break;
      case "Emergency Loan":
        displayStatus = emergencyLoan?.data?.loan_status || displayStatus;
        break;
      case "Development Loan":
        displayStatus = developmentLoan?.data?.loan_status || displayStatus;
        break;
      case "Jijenge Loan":
        displayStatus = jijengeLoan?.data?.loan_status || displayStatus;
        break;
      default:
        break;
    }
  }

  // ✅ FINAL reusable formatted status
  const formattedStatus = displayStatus
    ? displayStatus.charAt(0).toUpperCase() +
      displayStatus.slice(1).toLowerCase()
    : "";

  return (
    <div>
      {showStatementSuccess && (
        <StatementSuccess closeStatementSuccess={closeStatementSuccess} />
      )}
      <AnimatePresence>
        {showStatements && (
          <>
            {/* Background overlay */}
            <motion.div
              className="fixed inset-0 bg-black/30 z-40"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => setShowStatements(false)}
            />

            {/* Sliding modal */}
            <motion.div
              className="fixed right-[0.5%] top-[1%] bottom-[1%] bg-white shadow-lg rounded-2xl z-50 flex flex-col"
              style={{ width: 450 }}
              initial={{ x: "100%" }}
              animate={{ x: 0 }}
              exit={{ x: "100%" }}
              transition={{ type: "spring", stiffness: 100, damping: 20 }}
            >
              <div className="w-full h-full p-[20px] flex flex-col justify-between relative">
                <div
                  onClick={() => setShowStatements(false)}
                  className="absolute top-[0px] cursor-pointer h-[40px] w-[40px] bg-[#FF0000] rounded-tr-[10px] rounded-bl-[20px] right-[0px] flex items-center justify-center"
                >
                  <X color="#ffffff" />
                </div>
                <div className="h-[90%] w-full">
                  <p className="font-bold text-[#000000] text-[20px]">
                    Generate Statement
                  </p>
                  <p className="font-light text-[#737373] my-[15px] text-[15px]">
                    Create and download a full account statement for the chosen
                    period.
                  </p>
                  <p className="font-medium text-[#000000] mb-[10px] text-[16px]">
                    Select Date Range
                  </p>
                  <div className="w-full flex justify-between items-center">
                    <Calendar
                      startDate={fromDate}
                      endDate={toDate}
                      setStartDate={setFromDate}
                      setEndDate={setToDate}
                      focusedInput={customerFocusedInput}
                      setFocusedInput={setCustomerFocusedInput}
                    />
                  </div>
                </div>
                <div className="h-[10%] w-full flex items-center">
                  <button
                    disabled={loadingStatements}
                    onClick={handleGenerateStatement}
                    className="bg-[#074073] text-white text-[15px] font-bold rounded-sm w-full h-[45px] flex gap-[5px] items-center justify-center"
                  >
                    {loadingStatements && <Loading />}
                    Generate Statement
                  </button>
                </div>
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>
      <div className="h-[118px] bg-[#005C53] w-full flex items-center justify-between px-[20px]">
        <div className="flex items-center gap-[30px]">
          <div className="h-[80px] w-[80px] rounded-[100%] bg-[#F0FFFE] text-[#005C53] text-[24px] flex items-center justify-center">
            {customer?.firstname?.slice(0, 1)}
            {customer?.lastname?.slice(0, 1)}
          </div>
          <div className="flex flex-col ">
            <p className="text-[#F0FFFE] text-[14px]">{customer?.public_id}</p>
            <p className="text-white text-[24px]">
              {customer?.firstname?.charAt(0)?.toUpperCase() +
                customer?.firstname?.slice(1)?.toLowerCase()}{" "}
              {customer?.lastname?.charAt(0)?.toUpperCase() +
                customer?.lastname?.slice(1)?.toLowerCase()}
            </p>
            <p className="text-[#F0FFFE] text-[14px]">{customer?.username}</p>
          </div>
          <div className="h-[44px] rounded-[30px] bg-[#8ED6A8] flex gap-[5px] justify-center items-center px-3">
            {formattedStatus?.toLowerCase() === "active" && (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="9"
                height="9"
                viewBox="0 0 9 9"
                fill="none"
              >
                <circle cx="4.5" cy="4.5" r="4.5" fill="#005C53" />
              </svg>
            )}
            {formattedStatus?.toLowerCase() === "closed" && (
              <svg
                width="15"
                height="14"
                viewBox="0 0 15 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.28125 7.72476V3.85938V7.72476ZM13.5625 7C13.5625 8.66589 12.9007 10.2636 11.7228 11.4415C10.5448 12.6195 8.94714 13.2812 7.28125 13.2812C5.61536 13.2812 4.0177 12.6195 2.83974 11.4415C1.66177 10.2636 1 8.66589 1 7C1 5.33411 1.66177 3.73645 2.83974 2.55849C4.0177 1.38052 5.61536 0.71875 7.28125 0.71875C8.94714 0.71875 10.5448 1.38052 11.7228 2.55849C12.9007 3.73645 13.5625 5.33411 13.5625 7Z"
                  fill="#FF5757"
                />
                <path
                  d="M7.28125 7.72476V3.85937M13.5625 7C13.5625 8.66589 12.9007 10.2636 11.7228 11.4415C10.5448 12.6195 8.94714 13.2812 7.28125 13.2812C5.61536 13.2812 4.0177 12.6195 2.83974 11.4415C1.66177 10.2636 1 8.66589 1 7C1 5.33411 1.66177 3.73645 2.83974 2.55849C4.0177 1.38052 5.61536 0.71875 7.28125 0.71875C8.94714 0.71875 10.5448 1.38052 11.7228 2.55849C12.9007 3.73645 13.5625 5.33411 13.5625 7Z"
                  stroke="white"
                  strokeWidth="1.3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M7.7642 9.89894C7.7642 10.0271 7.71329 10.15 7.62268 10.2406C7.53207 10.3312 7.40917 10.3821 7.28102 10.3821C7.15288 10.3821 7.02998 10.3312 6.93937 10.2406C6.84876 10.15 6.79785 10.0271 6.79785 9.89894C6.79785 9.7708 6.84876 9.6479 6.93937 9.55729C7.02998 9.46668 7.15288 9.41577 7.28102 9.41577C7.40917 9.41577 7.53207 9.46668 7.62268 9.55729C7.71329 9.6479 7.7642 9.7708 7.7642 9.89894Z"
                  fill="#FF5757"
                  stroke="white"
                />
              </svg>
            )}
            {formattedStatus?.toLowerCase() === "rejected" && (
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <mask
                  id="mask0_3697_3201"
                  maskType="luminance"
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="14"
                  height="14"
                >
                  <path
                    d="M0 0.32002C0 0.154334 0.134315 0.0200195 0.3 0.0200195H13.7C13.8657 0.0200195 14 0.154334 14 0.32002V13.6801C14 13.8458 13.8657 13.9801 13.7 13.9801H0.3C0.134315 13.9801 0 13.8458 0 13.6801V0.32002Z"
                    fill="white"
                  />
                </mask>
                <g mask="url(#mask0_3697_3201)">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M14 0.32002C14 0.154334 13.8657 0.0200195 13.7 0.0200195H0.3C0.134315 0.0200195 0 0.154334 0 0.32002V13.6801C0 13.8458 0.134315 13.9801 0.3 13.9801H13.7C13.8657 13.9801 14 13.8458 14 13.6801V0.32002ZM10.3647 3.88232C10.4159 3.82394 10.4549 3.75594 10.4793 3.68232C10.5038 3.6087 10.5133 3.53094 10.5072 3.45362C10.501 3.3763 10.4795 3.30097 10.4438 3.23208C10.408 3.16319 10.3588 3.10212 10.2991 3.05247C10.2393 3.00282 10.1702 2.96558 10.0958 2.94296C10.0214 2.92033 9.94322 2.91277 9.86585 2.92071C9.78848 2.92866 9.71348 2.95196 9.64527 2.98924C9.57706 3.02652 9.51701 3.07702 9.46867 3.13778L7.2302 5.81607C7.11028 5.95956 6.88973 5.95955 6.76981 5.81606L4.53162 3.13778C4.48299 3.07789 4.4229 3.02824 4.35485 2.9917C4.2868 2.95517 4.21215 2.93248 4.13523 2.92496C4.05832 2.91744 3.98067 2.92524 3.9068 2.94789C3.83293 2.97055 3.76432 3.00762 3.70494 3.05694C3.64556 3.10627 3.5966 3.16687 3.56091 3.23522C3.52522 3.30358 3.5035 3.37832 3.49702 3.45512C3.49055 3.53191 3.49944 3.60922 3.52318 3.68256C3.54693 3.75589 3.58505 3.8238 3.63533 3.88232L6.08003 6.8077C6.17309 6.91907 6.17309 7.08109 6.08003 7.19245L3.63533 10.1178C3.58412 10.1762 3.54513 10.2442 3.52066 10.3178C3.49619 10.3915 3.48673 10.4692 3.49284 10.5465C3.49895 10.6239 3.52051 10.6992 3.55625 10.7681C3.59198 10.837 3.64118 10.898 3.70093 10.9477C3.76068 10.9973 3.82979 11.0346 3.90419 11.0572C3.97859 11.0798 4.05678 11.0874 4.13415 11.0794C4.21152 11.0715 4.28652 11.0482 4.35473 11.0109C4.42294 10.9736 4.48299 10.9231 4.53133 10.8624L6.76981 8.18407C6.88973 8.04058 7.11027 8.04058 7.23019 8.18407L9.46867 10.8624C9.51701 10.9231 9.57706 10.9736 9.64527 11.0109C9.71348 11.0482 9.78848 11.0715 9.86585 11.0794C9.94322 11.0874 10.0214 11.0798 10.0958 11.0572C10.1702 11.0346 10.2393 10.9973 10.2991 10.9477C10.3588 10.898 10.408 10.837 10.4438 10.7681C10.4795 10.6992 10.501 10.6239 10.5072 10.5465C10.5133 10.4692 10.5038 10.3915 10.4793 10.3178C10.4549 10.2442 10.4159 10.1762 10.3647 10.1178L7.91997 7.19245C7.82691 7.08109 7.82691 6.91907 7.91997 6.8077L10.3647 3.88232Z"
                    fill="#FF5757"
                  />
                </g>
              </svg>
            )}
            {formattedStatus?.toLowerCase() === "suspended" && (
              <svg
                width="16"
                height="13"
                viewBox="0 0 16 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2.35259 12.7498H13.6476C14.8026 12.7498 15.5226 11.4973 14.9451 10.4998L9.29759 0.742266C8.72009 -0.255234 7.28009 -0.255234 6.70259 0.742266L1.05509 10.4998C0.477591 11.4973 1.19759 12.7498 2.35259 12.7498ZM8.00009 7.49977C7.58759 7.49977 7.25009 7.16227 7.25009 6.74977V5.24977C7.25009 4.83727 7.58759 4.49977 8.00009 4.49977C8.41259 4.49977 8.75009 4.83727 8.75009 5.24977V6.74977C8.75009 7.16227 8.41259 7.49977 8.00009 7.49977ZM8.75009 10.4998H7.25009V8.99977H8.75009V10.4998Z"
                  fill="#FAB32B"
                />
              </svg>
            )}
            {formattedStatus?.toLowerCase() === "pending" && (
              <svg
                width="15"
                height="15"
                viewBox="0 0 15 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3.75 8.625C4.0625 8.625 4.32825 8.5155 4.54725 8.2965C4.76625 8.0775 4.8755 7.812 4.875 7.5C4.875 7.1875 4.7655 6.92175 4.5465 6.70275C4.3275 6.48375 4.062 6.3745 3.75 6.375C3.4375 6.375 3.17175 6.4845 2.95275 6.7035C2.73375 6.9225 2.6245 7.188 2.625 7.5C2.625 7.8125 2.7345 8.07825 2.9535 8.29725C3.1725 8.51625 3.438 8.6255 3.75 8.625ZM7.5 8.625C7.8125 8.625 8.07825 8.5155 8.29725 8.2965C8.51625 8.0775 8.6255 7.812 8.625 7.5C8.625 7.1875 8.5155 6.92175 8.2965 6.70275C8.0775 6.48375 7.812 6.3745 7.5 6.375C7.1875 6.375 6.92175 6.4845 6.70275 6.7035C6.48375 6.9225 6.3745 7.188 6.375 7.5C6.375 7.8125 6.4845 8.07825 6.7035 8.29725C6.9225 8.51625 7.188 8.6255 7.5 8.625ZM11.25 8.625C11.5625 8.625 11.8282 8.5155 12.0472 8.2965C12.2662 8.0775 12.3755 7.812 12.375 7.5C12.375 7.1875 12.2655 6.92175 12.0465 6.70275C11.8275 6.48375 11.562 6.3745 11.25 6.375C10.9375 6.375 10.6717 6.4845 10.4527 6.7035C10.2337 6.9225 10.1245 7.188 10.125 7.5C10.125 7.8125 10.2345 8.07825 10.4535 8.29725C10.6725 8.51625 10.938 8.6255 11.25 8.625ZM7.5 15C6.4625 15 5.4875 14.803 4.575 14.409C3.6625 14.015 2.86875 13.4807 2.19375 12.8062C1.51875 12.1312 0.9845 11.3375 0.591 10.425C0.1975 9.5125 0.0005 8.5375 0 7.5C0 6.4625 0.197 5.4875 0.591 4.575C0.985 3.6625 1.51925 2.86875 2.19375 2.19375C2.86875 1.51875 3.6625 0.9845 4.575 0.591C5.4875 0.1975 6.4625 0.0005 7.5 0C8.5375 0 9.5125 0.197 10.425 0.591C11.3375 0.985 12.1312 1.51925 12.8062 2.19375C13.4812 2.86875 14.0157 3.6625 14.4097 4.575C14.8037 5.4875 15.0005 6.4625 15 7.5C15 8.5375 14.803 9.5125 14.409 10.425C14.015 11.3375 13.4807 12.1312 12.8062 12.8062C12.1312 13.4812 11.3375 14.0157 10.425 14.4097C9.5125 14.8037 8.5375 15.0005 7.5 15Z"
                  fill="#554D4D"
                />
              </svg>
            )}

            {formattedStatus?.toLowerCase() === "pending approval" && (
              <svg
                width="15"
                height="15"
                viewBox="0 0 15 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3.75 8.625C4.0625 8.625 4.32825 8.5155 4.54725 8.2965C4.76625 8.0775 4.8755 7.812 4.875 7.5C4.875 7.1875 4.7655 6.92175 4.5465 6.70275C4.3275 6.48375 4.062 6.3745 3.75 6.375C3.4375 6.375 3.17175 6.4845 2.95275 6.7035C2.73375 6.9225 2.6245 7.188 2.625 7.5C2.625 7.8125 2.7345 8.07825 2.9535 8.29725C3.1725 8.51625 3.438 8.6255 3.75 8.625ZM7.5 8.625C7.8125 8.625 8.07825 8.5155 8.29725 8.2965C8.51625 8.0775 8.6255 7.812 8.625 7.5C8.625 7.1875 8.5155 6.92175 8.2965 6.70275C8.0775 6.48375 7.812 6.3745 7.5 6.375C7.1875 6.375 6.92175 6.4845 6.70275 6.7035C6.48375 6.9225 6.3745 7.188 6.375 7.5C6.375 7.8125 6.4845 8.07825 6.7035 8.29725C6.9225 8.51625 7.188 8.6255 7.5 8.625ZM11.25 8.625C11.5625 8.625 11.8282 8.5155 12.0472 8.2965C12.2662 8.0775 12.3755 7.812 12.375 7.5C12.375 7.1875 12.2655 6.92175 12.0465 6.70275C11.8275 6.48375 11.562 6.3745 11.25 6.375C10.9375 6.375 10.6717 6.4845 10.4527 6.7035C10.2337 6.9225 10.1245 7.188 10.125 7.5C10.125 7.8125 10.2345 8.07825 10.4535 8.29725C10.6725 8.51625 10.938 8.6255 11.25 8.625ZM7.5 15C6.4625 15 5.4875 14.803 4.575 14.409C3.6625 14.015 2.86875 13.4807 2.19375 12.8062C1.51875 12.1312 0.9845 11.3375 0.591 10.425C0.1975 9.5125 0.0005 8.5375 0 7.5C0 6.4625 0.197 5.4875 0.591 4.575C0.985 3.6625 1.51925 2.86875 2.19375 2.19375C2.86875 1.51875 3.6625 0.9845 4.575 0.591C5.4875 0.1975 6.4625 0.0005 7.5 0C8.5375 0 9.5125 0.197 10.425 0.591C11.3375 0.985 12.1312 1.51925 12.8062 2.19375C13.4812 2.86875 14.0157 3.6625 14.4097 4.575C14.8037 5.4875 15.0005 6.4625 15 7.5C15 8.5375 14.803 9.5125 14.409 10.425C14.015 11.3375 13.4807 12.1312 12.8062 12.8062C12.1312 13.4812 11.3375 14.0157 10.425 14.4097C9.5125 14.8037 8.5375 15.0005 7.5 15Z"
                  fill="#554D4D"
                />
              </svg>
            )}

            {formattedStatus?.toLowerCase() === "approved" && (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="9"
                height="9"
                viewBox="0 0 9 9"
                fill="none"
              >
                <circle cx="4.5" cy="4.5" r="4.5" fill="#005C53" />
              </svg>
            )}
            <p className="text-[#005C53] text-[14px]">{formattedStatus}</p>
          </div>
        </div>
        <div className="flex flex-col gap-[10px]">
          <div
            onClick={openContinueSuspendAcc}
            className="w-[194px] cursor-pointer h-[31px] bg-[#FAB32B] gap-[10px] rounded-[40px] flex items-center p-[10px]"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="21"
              height="21"
              viewBox="0 0 21 21"
              fill="none"
            >
              <path
                d="M3.91136 18.375H17.0889C18.4364 18.375 19.2764 16.9137 18.6026 15.75L12.0139 4.36622C11.3401 3.20247 9.66011 3.20247 8.98636 4.36622L2.39761 15.75C1.72386 16.9137 2.56386 18.375 3.91136 18.375ZM10.5001 12.25C10.0189 12.25 9.62511 11.8562 9.62511 11.375V9.62497C9.62511 9.14372 10.0189 8.74997 10.5001 8.74997C10.9814 8.74997 11.3751 9.14372 11.3751 9.62497V11.375C11.3751 11.8562 10.9814 12.25 10.5001 12.25ZM11.3751 15.75H9.62511V14H11.3751V15.75Z"
                fill="white"
              />
            </svg>
            <p className="text-white text-[14px]">Suspend Account</p>
          </div>
          <div
            onClick={OpenContinueCloseAcc}
            className="w-[194px] cursor-pointer h-[31px] bg-[#FF5757] gap-[10px] rounded-[40px] flex items-center p-[10px]"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M5.83301 17.5C5.37467 17.5 4.98217 17.3367 4.65551 17.01C4.32884 16.6833 4.16579 16.2911 4.16634 15.8333V5H3.33301V3.33333H7.49967V2.5H12.4997V3.33333H16.6663V5H15.833V15.8333C15.833 16.2917 15.6697 16.6842 15.343 17.0108C15.0163 17.3375 14.6241 17.5006 14.1663 17.5H5.83301ZM7.49967 14.1667H9.16634V6.66667H7.49967V14.1667ZM10.833 14.1667H12.4997V6.66667H10.833V14.1667Z"
                fill="white"
              />
            </svg>
            <p className="text-white text-[14px]">Close Account</p>
          </div>
        </div>
      </div>
      <div className="my-[10px] px-[20px]">
        <button
          onClick={handleBack}
          className="bg-[#005C53] h-[40px] text-white text-[16px] w-[140px] rounded flex items-center justify-center gap-[10px] px-[20px]"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1.78em"
            height="1em"
            viewBox="0 0 16 9"
          >
            <path
              fill="currentColor"
              d="M12.5 5h-9c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h9c.28 0 .5.22.5.5s-.22.5-.5.5"
            />
            <path
              fill="currentColor"
              d="M6 8.5a.47.47 0 0 1-.35-.15l-3.5-3.5c-.2-.2-.2-.51 0-.71L5.65.65c.2-.2.51-.2.71 0c.2.2.2.51 0 .71L3.21 4.51l3.15 3.15c.2.2.2.51 0 .71c-.1.1-.23.15-.35.15Z"
            />
          </svg>
          Back
        </button>
      </div>
      <div className="p-[10px] h-[700px] overflow-y-auto">
        <div
          className="w-full mb-[10px] px-[10px] py-[5px] bg-white"
          style={{ boxShadow: "0px 0px 4px 0px rgba(0, 0, 0, 0.25)" }}
        >
          <p className="text-[#005C53] text-[16px]">Account</p>
          <div className="w-full flex justify-between">
            <div className="w-full flex items-start gap-[20px]">
              <div
                style={{ backgroundColor: `${state?.color}` }}
                className="bg-image-1 h-[165px] mb-[20px] rounded-[10px] w-[40%] p-[10px]"
              >
                <div className="w-full flex items-center justify-between">
                  <p className="text-[#FFFFFFB2] text-[12px]">Account Type</p>
                  <p className="text-[#D6D58EB2] text-[12px]">Account Number</p>
                </div>
                <div className="w-full flex items-center justify-between">
                  <p className="text-[#D6D58E] text-[20px]">
                    {singleAccount?.product?.name} Account
                  </p>
                  <p className="text-[#D6D58E] text-[16px]">
                    {singleAccount?.account_number}
                  </p>
                </div>
                <div>
                  <p className="text-[#FFFFFFB2] text-[12px]">
                    Account Balance
                  </p>
                </div>
                <div className="flex items-center justify-between w-full">
                  <div className="flex items-center gap-[5px]">
                    <p className="text-white font-bold">KES.</p>
                    <p
                      className={showBalance ? `blur` : ""}
                      style={{ color: "white", fontSize: "16px" }}
                    >
                      <span className="text-[36px] text-[#D6D58E] font-bold">
                        {(
                          Number(
                            singleAccount?.product?.name === "Flash Loan"
                              ? (flashLoan?.data?.loan_balance ?? 0)
                              : singleAccount?.product?.name === "Normal Loan"
                                ? (normalLoan?.data?.loan_balance ?? 0)
                                : singleAccount?.product?.name ===
                                    "Emergency Loan"
                                  ? (emergencyLoan?.data?.loan_balance ?? 0)
                                  : singleAccount?.product?.name ===
                                      "Development Loan"
                                    ? (developmentLoan?.data?.loan_balance ?? 0)
                                    : singleAccount?.product?.name ===
                                        "Jijenge Loan"
                                      ? (jijengeLoan?.data?.loan_balance ?? 0)
                                      : (singleAccount?.balance ?? 0),
                          ) || 0
                        ).toLocaleString("en-US", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </span>
                    </p>
                  </div>

                  <div className="bg-[#F0FFFE] w-[28px] h-[20px] rounded-[60%] flex items-center justify-center">
                    {showBalance ? (
                      <svg
                        onClick={toggleBalanceVisibility}
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        className="cursor-pointer"
                      >
                        <g
                          fill="none"
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                        >
                          <path d="M10 12a2 2 0 1 0 4 0a2 2 0 0 0-4 0" />
                          <path d="M21 12c-2.4 4-5.4 6-9 6c-3.6 0-6.6-2-9-6c2.4-4 5.4-6 9-6c3.6 0 6.6 2 9 6" />
                        </g>
                      </svg>
                    ) : (
                      <svg
                        onClick={toggleBalanceVisibility}
                        className="cursor-pointer"
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="-2 -2 24 24"
                      >
                        <path
                          fill="currentColor"
                          d="m15.398 7.23l1.472-1.472C18.749 6.842 20 8.34 20 10c0 3.314-4.958 5.993-10 6a14.734 14.734 0 0 1-3.053-.32l1.747-1.746c.426.044.862.067 1.303.066h.002c-.415 0-.815-.063-1.191-.18l1.981-1.982c.47-.202.847-.579 1.05-1.049l1.98-1.981A4 4 0 0 1 10.022 14C14.267 13.985 18 11.816 18 10c0-.943-1.022-1.986-2.602-2.77m-9.302 3.645A4 4 0 0 1 9.993 6C5.775 5.985 2 8.178 2 10c0 .896.904 1.877 2.327 2.644L2.869 14.1C1.134 13.028 0 11.585 0 10c0-3.314 4.984-6.017 10-6c.914.003 1.827.094 2.709.262l-1.777 1.776c-.29-.022-.584-.035-.88-.038c.282.004.557.037.823.096l-4.78 4.779zM19.092.707a1 1 0 0 1 0 1.414l-16.97 16.97a1 1 0 1 1-1.415-1.413L17.677.708a1 1 0 0 1 1.415 0z"
                        />
                      </svg>
                    )}
                  </div>
                </div>
              </div>
              <div className="w-[60%] flex flex-col gap-[20px]">
                <div className="w-[48%] flex items-center justify-between">
                  <p>Created on</p>
                  <p className="text-right">
                    {singleAccount?.createdAt
                      ? new Date(singleAccount?.createdAt)
                          ?.toISOString()
                          ?.split("T")[0]
                      : "N/A"}
                  </p>
                </div>

                <div className="w-[48%] flex items-center justify-between">
                  <p>
                    {singleAccount?.product?.name === "Savings"
                      ? "Total saved this month"
                      : singleAccount?.product?.name === "Shares"
                        ? "Total shares purchased this month"
                        : "Total paid this month"}
                  </p>
                  <p className="text-right">
                    {Number(spending?.total_spent_month)?.toFixed(2)}
                  </p>
                </div>
              </div>
            </div>
            <div>
              <Dropdown
                menu={{ items }}
                trigger={["click"]}
                placement="bottomLeft"
              >
                <button className="flex items-center gap-2 bg-[#316CE9] hover:bg-[#316CE9] text-white px-3 py-2 rounded-lg transition">
                  <img height={18} width={18} src="/flash.png" alt="flash" />
                  <span>Actions</span>
                  <ChevronDown size={20} className="opacity-80" />
                </button>
              </Dropdown>
            </div>
          </div>

          <div className="mb-[20px] flex items-center justify-end w-full">
            <PermissionGate required={[PERMISSIONS?.SV?.ADD_DEPOSIT]}>
              {singleAccount?.product?.name === "Savings" && (
                <button
                  onClick={openAddTransactionSavingsOpen}
                  className="block text-white bg-[#005C53] focus:outline-none focus:ring-[#005C53] rounded-[30px] text-center w-[221px] h-[42px]"
                  type="button"
                >
                  <div className="flex items-center justify-center gap-4">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M11 13H5V11H11V5H13V11H19V13H13V19H11V13Z"
                        fill="white"
                      />
                    </svg>
                    <p className="text-[#FFF] text-[14px]">Add Payment</p>
                  </div>
                </button>
              )}
            </PermissionGate>
            <PermissionGate required={[PERMISSIONS?.SH?.ADD_DEPOSIT]}>
              {singleAccount?.product?.name === "Shares" && (
                <button
                  onClick={openSharesAddTransactionOpen}
                  className="block text-white bg-[#005C53] focus:outline-none focus:ring-[#005C53] rounded-[30px] text-center w-[221px] h-[42px]"
                  type="button"
                >
                  <div className="flex items-center justify-center gap-4">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M11 13H5V11H11V5H13V11H19V13H13V19H11V13Z"
                        fill="white"
                      />
                    </svg>
                    <p className="text-[#FFF] text-[14px]">Add Payment</p>
                  </div>
                </button>
              )}
            </PermissionGate>
            <PermissionGate required={[PERMISSIONS?.LN?.ADD_DEPOSIT]}>
              {[
                "Flash Loan",
                "Normal Loan",
                "Development Loan",
                "Emergency Loan",
              ]?.includes(singleAccount?.product?.name) &&
                formattedStatus?.toLowerCase() === "active" && (
                  <button
                    onClick={openLoanAddTransactionsOpen}
                    className="block text-white bg-[#005C53] focus:outline-none focus:ring-[#005C53] rounded-[30px] text-center w-[182px] h-[44px]"
                    type="button"
                  >
                    <div className="flex items-center justify-center gap-4">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <path
                          d="M11 13H5V11H11V5H13V11H19V13H13V19H11V13Z"
                          fill="white"
                        />
                      </svg>
                      <p className="text-[#FFF] text-[14px]">Add Payment</p>
                    </div>
                  </button>
                )}
            </PermissionGate>
          </div>

          {[
            "Flash Loan",
            "Normal Loan",
            "Emergency Loan",
            "Development Loan",
          ]?.includes(singleAccount?.product?.name) ? (
            <div className="flex flex-col w-full">
              <div className="w-full flex items-center bg-[#E3F8FF] px-[10px] min-h-[44px]">
                <div className="w-[10%]">
                  <input type="checkbox" name="" id="" />
                </div>
                <p className="w-[20%] text-[#000]">LOAN CODE</p>
                <p className="w-[14%] text-[#000]">AMOUNT</p>
                <p className="w-[20%] text-[#000]">RECIPIENT</p>
                <p className="w-[10%] text-[#000]">TYPE</p>
                <p className="w-[14%] text-[#000]">DATE</p>
                <p className="w-[14%] text-[#000]">STATUS</p>
              </div>
              <div className="h-[430px] overflow-y-auto">
                {flashTrans?.length > 0 ? (
                  <>
                    {flashTrans?.map((loanflash) => (
                      <div
                        onClick={() => openTransactionModal(loanflash)}
                        key={loanflash?.loan_code}
                        className="w-full flex cursor-pointer items-center bg-white px-[10px] min-h-[44px]"
                      >
                        <div className="w-[10%]">
                          <input
                            type="checkbox"
                            name="transaction"
                            id="transaction"
                          />
                        </div>
                        <p className="w-[20%] text-[#06B217]">
                          {loanflash?.loan_code}
                        </p>
                        <p className="w-[14%]">
                          KES &nbsp;
                          {Number(
                            loanflash?.payment_amount || "0.00",
                          )?.toLocaleString("en-US", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </p>

                        <p className="w-[20%]">
                          {customer?.firstname?.charAt(0)?.toUpperCase() +
                            customer?.firstname?.slice(1)?.toLowerCase()}{" "}
                          {customer?.lastname?.charAt(0)?.toUpperCase() +
                            customer?.lastname?.slice(1)?.toLowerCase()}
                        </p>
                        <p className="w-[10%]">Loan</p>
                        <p className="w-[14%]">
                          {loanflash?.payment_date
                            ? new Date(loanflash?.payment_date)
                                ?.toISOString()
                                ?.split("T")[0]
                            : "N/A"}
                        </p>
                        <div className="w-[14%] flex items-center gap-[10px]">
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M8 0C8.73438 0 9.44271 0.09375 10.125 0.28125C10.8073 0.46875 11.4427 0.739583 12.0312 1.09375C12.6198 1.44792 13.1589 1.86458 13.6484 2.34375C14.138 2.82292 14.5573 3.36198 14.9062 3.96094C15.2552 4.5599 15.5234 5.19792 15.7109 5.875C15.8984 6.55208 15.9948 7.26042 16 8C16 8.73438 15.9062 9.44271 15.7188 10.125C15.5312 10.8073 15.2604 11.4427 14.9062 12.0312C14.5521 12.6198 14.1354 13.1589 13.6562 13.6484C13.1771 14.138 12.638 14.5573 12.0391 14.9062C11.4401 15.2552 10.8021 15.5234 10.125 15.7109C9.44792 15.8984 8.73958 15.9948 8 16C7.26562 16 6.55729 15.9062 5.875 15.7188C5.19271 15.5312 4.55729 15.2604 3.96875 14.9062C3.38021 14.5521 2.84115 14.1354 2.35156 13.6562C1.86198 13.1771 1.44271 12.638 1.09375 12.0391C0.744792 11.4401 0.476562 10.8021 0.289062 10.125C0.101562 9.44792 0.00520833 8.73958 0 8C0 7.26562 0.09375 6.55729 0.28125 5.875C0.46875 5.19271 0.739583 4.55729 1.09375 3.96875C1.44792 3.38021 1.86458 2.84115 2.34375 2.35156C2.82292 1.86198 3.36198 1.44271 3.96094 1.09375C4.5599 0.744792 5.19792 0.476562 5.875 0.289062C6.55208 0.101562 7.26042 0.00520833 8 0ZM12.7109 5.35156L11.6484 4.28906L6.5 9.4375L4.35156 7.28906L3.28906 8.35156L6.5 11.5625L12.7109 5.35156Z"
                              fill="#0C722F"
                            />
                          </svg>
                          <p>Completed</p>
                        </div>
                      </div>
                    ))}
                  </>
                ) : (
                  <p className="mt-[10px]">No record of transactions</p>
                )}
              </div>
            </div>
          ) : (
            <div className="flex flex-col w-full">
              <div className="w-full flex items-center bg-[#E3F8FF] px-[10px] min-h-[44px]">
                <div className="w-[10%]">
                  <input type="checkbox" name="" id="" />
                </div>
                <p className="w-[20%] text-[#000]">TRANSACTION ID</p>
                <p className="w-[14%] text-[#000]">AMOUNT</p>
                <p className="w-[10%] text-[#000]">TYPE</p>
                <p className="w-[20%] text-[#000]">RECIPIENT</p>
                <p className="w-[14%] text-[#000]">DATE</p>
                <p className="w-[14%] text-[#000]">STATUS</p>
              </div>
              <div className="h-[430px] overflow-y-auto">
                {transactions?.length > 0 ? (
                  <>
                    {transactions?.map((transaction) => (
                      <div
                        onClick={() => openTransactionModal(transaction)}
                        key={transaction?.id}
                        className="w-full flex cursor-pointer items-center bg-white px-[10px] min-h-[44px]"
                      >
                        <div className="w-[10%]">
                          <input
                            type="checkbox"
                            name="transaction"
                            id="transaction"
                          />
                        </div>
                        <p className="w-[20%] text-[#06B217]">
                          {transaction?.public_id}
                        </p>
                        <p className="w-[14%]">
                          KES &nbsp;
                          {Number(
                            transaction?.amount || "0.00",
                          )?.toLocaleString("en-US", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </p>
                        <p className="w-[10%]">
                          {capitalize(transaction?.type)}
                        </p>
                        <p className="w-[20%]">
                          {transaction?.receiver_name
                            ?.charAt(0)
                            ?.toUpperCase() +
                            transaction?.receiver_name?.slice(1)?.toLowerCase()}
                        </p>
                        <p className="w-[14%]">
                          {transaction?.createdAt
                            ? new Date(transaction?.createdAt)
                                ?.toISOString()
                                ?.split("T")[0]
                            : "N/A"}
                        </p>
                        <div className="w-[14%] flex items-center gap-[10px]">
                          {transaction?.status?.toLowerCase() ===
                            "completed" && (
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M8 0C8.73438 0 9.44271 0.09375 10.125 0.28125C10.8073 0.46875 11.4427 0.739583 12.0312 1.09375C12.6198 1.44792 13.1589 1.86458 13.6484 2.34375C14.138 2.82292 14.5573 3.36198 14.9062 3.96094C15.2552 4.5599 15.5234 5.19792 15.7109 5.875C15.8984 6.55208 15.9948 7.26042 16 8C16 8.73438 15.9062 9.44271 15.7188 10.125C15.5312 10.8073 15.2604 11.4427 14.9062 12.0312C14.5521 12.6198 14.1354 13.1589 13.6562 13.6484C13.1771 14.138 12.638 14.5573 12.0391 14.9062C11.4401 15.2552 10.8021 15.5234 10.125 15.7109C9.44792 15.8984 8.73958 15.9948 8 16C7.26562 16 6.55729 15.9062 5.875 15.7188C5.19271 15.5312 4.55729 15.2604 3.96875 14.9062C3.38021 14.5521 2.84115 14.1354 2.35156 13.6562C1.86198 13.1771 1.44271 12.638 1.09375 12.0391C0.744792 11.4401 0.476562 10.8021 0.289062 10.125C0.101562 9.44792 0.00520833 8.73958 0 8C0 7.26562 0.09375 6.55729 0.28125 5.875C0.46875 5.19271 0.739583 4.55729 1.09375 3.96875C1.44792 3.38021 1.86458 2.84115 2.34375 2.35156C2.82292 1.86198 3.36198 1.44271 3.96094 1.09375C4.5599 0.744792 5.19792 0.476562 5.875 0.289062C6.55208 0.101562 7.26042 0.00520833 8 0ZM12.7109 5.35156L11.6484 4.28906L6.5 9.4375L4.35156 7.28906L3.28906 8.35156L6.5 11.5625L12.7109 5.35156Z"
                                fill="#0C722F"
                              />
                            </svg>
                          )}
                          {transaction?.status?.toLowerCase() === "pending" && (
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M3.75 8.625C4.0625 8.625 4.32825 8.5155 4.54725 8.2965C4.76625 8.0775 4.8755 7.812 4.875 7.5C4.875 7.1875 4.7655 6.92175 4.5465 6.70275C4.3275 6.48375 4.062 6.3745 3.75 6.375C3.4375 6.375 3.17175 6.4845 2.95275 6.7035C2.73375 6.9225 2.6245 7.188 2.625 7.5C2.625 7.8125 2.7345 8.07825 2.9535 8.29725C3.1725 8.51625 3.438 8.6255 3.75 8.625ZM7.5 8.625C7.8125 8.625 8.07825 8.5155 8.29725 8.2965C8.51625 8.0775 8.6255 7.812 8.625 7.5C8.625 7.1875 8.5155 6.92175 8.2965 6.70275C8.0775 6.48375 7.812 6.3745 7.5 6.375C7.1875 6.375 6.92175 6.4845 6.70275 6.7035C6.48375 6.9225 6.3745 7.188 6.375 7.5C6.375 7.8125 6.4845 8.07825 6.7035 8.29725C6.9225 8.51625 7.188 8.6255 7.5 8.625ZM11.25 8.625C11.5625 8.625 11.8282 8.5155 12.0472 8.2965C12.2662 8.0775 12.3755 7.812 12.375 7.5C12.375 7.1875 12.2655 6.92175 12.0465 6.70275C11.8275 6.48375 11.562 6.3745 11.25 6.375C10.9375 6.375 10.6717 6.4845 10.4527 6.7035C10.2337 6.9225 10.1245 7.188 10.125 7.5C10.125 7.8125 10.2345 8.07825 10.4535 8.29725C10.6725 8.51625 10.938 8.6255 11.25 8.625ZM7.5 15C6.4625 15 5.4875 14.803 4.575 14.409C3.6625 14.015 2.86875 13.4807 2.19375 12.8062C1.51875 12.1312 0.9845 11.3375 0.591 10.425C0.1975 9.5125 0.0005 8.5375 0 7.5C0 6.4625 0.197 5.4875 0.591 4.575C0.985 3.6625 1.51925 2.86875 2.19375 2.19375C2.86875 1.51875 3.6625 0.9845 4.575 0.591C5.4875 0.1975 6.4625 0.0005 7.5 0C8.5375 0 9.5125 0.197 10.425 0.591C11.3375 0.985 12.1312 1.51925 12.8062 2.19375C13.4812 2.86875 14.0157 3.6625 14.4097 4.575C14.8037 5.4875 15.0005 6.4625 15 7.5C15 8.5375 14.803 9.5125 14.409 10.425C14.015 11.3375 13.4807 12.1312 12.8062 12.8062C12.1312 13.4812 11.3375 14.0157 10.425 14.4097C9.5125 14.8037 8.5375 15.0005 7.5 15Z"
                                fill="#FFCB35"
                              />
                            </svg>
                          )}
                          {transaction?.status?.toLowerCase() ===
                            "incomplete" && (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="9"
                              height="9"
                              viewBox="0 0 9 9"
                              fill="none"
                            >
                              <circle
                                cx="4.5"
                                cy="4.5"
                                r="4.5"
                                fill="#FAB32B"
                              />
                            </svg>
                          )}
                          <p>{capitalize(transaction?.status)}</p>
                        </div>
                      </div>
                    ))}
                  </>
                ) : (
                  <p className="mt-[10px]">No record of transactions</p>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
      <TransactionModal
        transactionDetailsOpen={openTransaction}
        closeTransactionDetails={closeTransactionModal}
        singleTransaction={singleTransaction}
        openViewReceipt={openViewReceipt}
      />

      <ViewReceipt
        viewReceiptOpen={viewReceiptOpen}
        closeViewReceipt={closeViewReceipt}
        singleTransaction={singleTransaction}
      />
      <ContinueSuspendAcc
        isContinueSuspendAccModalOpen={isContinueSuspendAccModalOpen}
        closeContinueSuspendAcc={closeContinueSuspendAcc}
        handleOpenSuspendReason={handleOpenSuspendReason}
      />
      <SuspensionReason
        id_R="suspension-reasons"
        suspendReasonOpen={suspendReasonOpen}
        handleCloseSuspendReason={handleCloseSuspendReason}
        handleOpenDocumentReason={handleOpenDocumentReason}
        selectedOption={selectedOption}
        setSelectedOption={setSelectedOption}
      />
      <DocumentReason
        id_R="document-reasons"
        documentReasonOpen={documentReasonOpen}
        handleCloseDocumentReason={handleCloseDocumentReason}
        handleOpenSuspensionImplications={handleOpenSuspensionImplications}
        handleOpenSuspendReason={handleOpenSuspendReason}
        note={note}
        setNote={setNote}
      />
      <SuspensionImplications
        id_R="suspension-implications"
        suspensionImplicationsOpen={suspensionImplicationsOpen}
        handleCloseSuspensionImplications={handleCloseSuspensionImplications}
        handleOpenReviewSuspension={handleOpenReviewSuspension}
        handleOpenDocumentReason={handleOpenDocumentReason}
        toggleState={toggleState}
        setToggleState={setToggleState}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
      />
      <ReviewSuspension
        id_R="review-suspension"
        reviewSuspensionOpen={reviewSuspensionOpen}
        handleCloseReviewSuspension={handleCloseReviewSuspension}
        handleOpenSuspendReason={handleOpenSuspendReason}
        handleOpenDocumentReason={handleOpenDocumentReason}
        handleOpenSuspensionImplications={handleOpenSuspensionImplications}
        activeTab={activeTab}
        toggleState={toggleState}
        note={note}
        selectedOption={selectedOption}
        firstName={customer?.firstname}
        lastName={customer?.lastname}
        accountNumber={singleAccount?.account_number}
        productName={singleAccount?.product?.name}
        setIsSuspendAccountModalOpen={setIsSuspendAccountModalOpen}
      />
      <SuspendAccount
        isSuspendAccountModalOpen={isSuspendAccountModalOpen}
        closeSuspendAccount={closeSuspendAccount}
        handleSuspendAccount={handleSuspendAccount}
      />
      <ContinueCloseAcc
        isContinueCloseAccModalOpen={isContinueCloseAccModalOpen}
        closeContinueCloseAcc={closeContinueCloseAcc}
        handleOpenClosureReason={handleOpenClosureReason}
      />
      <ClosureReason
        closureReasonOpen={closureReasonOpen}
        handleCloseClosureReason={handleCloseClosureReason}
        selectedReason={selectedReason}
        setSelectedReason={setSelectedReason}
        handleOpenUploadDocument={handleOpenUploadDocument}
      />

      <UploadDocument
        uploadDocumentOpen={uploadDocumentOpen}
        reason={reason}
        setReason={setReason}
        handleCloseUploadDocument={handleCloseUploadDocument}
        handleOpenClosureReason={handleOpenClosureReason}
        handleOpenClosureImplications={handleOpenClosureImplications}
      />
      <ClosureImplications
        closureImplicationsOpen={closureImplicationsOpen}
        handleCloseClosureImplications={handleCloseClosureImplications}
        handleOpenUploadDocument={handleOpenUploadDocument}
        confirmationStatus={confirmationStatus}
        setConfirmationStatus={setConfirmationStatus}
        selectedTab={selectedTab}
        setSelectedTab={setSelectedTab}
        handleOpenFinishClosure={handleOpenFinishClosure}
      />
      <FinishClosure
        finishClosureOpen={finishClosureOpen}
        handleCloseFinishClosure={handleCloseFinishClosure}
        handleOpenClosureReason={handleOpenClosureReason}
        handleOpenUploadDocument={handleOpenUploadDocument}
        handleOpenClosureImplications={handleOpenClosureImplications}
        firstName={customer?.firstname}
        lastName={customer?.lastname}
        accountNumber={singleAccount?.account_number}
        productName={singleAccount?.product?.name}
        selectedReason={selectedReason}
        reason={reason}
        selectedTab={selectedTab}
        confirmationStatus={confirmationStatus}
        setIsCloseAccountModalOpen={setIsCloseAccountModalOpen}
      />
      <CloseAccount
        isCloseAccountModalOpen={isCloseAccountModalOpen}
        closeCloseAccount={closeCloseAccount}
        handleCloseAccount={handleCloseAccount}
      />
      <AddTransactionSavings
        id="id_R"
        isAddTransactionSavingsOpen={isAddTransactionSavingsOpen}
        closeAddTransactionSavingsOpen={closeAddTransactionSavingsOpen}
        transMode={transMode}
        setTransMode={setTransMode}
        amount={amount}
        setAmount={setAmount}
        date={date}
        setDate={setDate}
        accNumber={accNumber}
        setAccNumber={setAccNumber}
        refNumber={refNumber}
        setRefNumber={setRefNumber}
        docFile={docFile}
        setDocFile={setDocFile}
        handleManualTransaction={handleManualTransaction}
        savingsChecked={savingsChecked}
        setSavingsChecked={setSavingsChecked}
      />

      <LoadingButtons isLoadingButtons={isLoadingButtons} />

      <PaymentAddedSuccessfully
        id="id_R"
        isPaymentAddedSuccessfullyOpen={isPaymentAddedSuccessfullyOpen}
        closePaymentAddedSuccessfully={closePaymentAddedSuccessfully}
      />

      <SharesAddTransaction
        id="id_R"
        isSharesAddTransactionOpen={isSharesAddTransactionOpen}
        closeSharesAddTransactionOpen={closeSharesAddTransactionOpen}
        sharesTransMode={sharesTransMode}
        setSharesTransMode={setSharesTransMode}
        sharesAmount={sharesAmount}
        setSharesAmount={setSharesAmount}
        sharesDate={sharesDate}
        setSharesDate={setSharesDate}
        sharesAccNumber={sharesAccNumber}
        setSharesAccNumber={setSharesAccNumber}
        sharesRefNumber={sharesRefNumber}
        setSharesRefNumber={setSharesRefNumber}
        sharesDocFile={sharesDocFile}
        setSharesDocFile={setSharesDocFile}
        isChecked={isChecked}
        setIsChecked={setIsChecked}
        handleSharesManualTransaction={handleSharesManualTransaction}
      />

      <LoanAddTransactions
        id="ID_R"
        isLoanAddTransactionsOpen={isLoanAddTransactionsOpen}
        closeLoanAddTransactionsOpen={closeLoanAddTransactionsOpen}
        loanTransMode={loanTransMode}
        setLoanTransMode={setLoanTransMode}
        loanAmount={loanAmount}
        setLoanAmount={setLoanAmount}
        loanDate={loanDate}
        setLoanDate={setLoanDate}
        loanAccNumber={loanAccNumber}
        setLoanAccNumber={setLoanAccNumber}
        loanRefNumber={loanRefNumber}
        setLoanRefNumber={setLoanRefNumber}
        loanDocFile={loanDocFile}
        setLoanDocFile={setLoanDocFile}
        handleManualLoanPayment={handleManualLoanPayment}
        loansChecked={loansChecked}
        setLoansChecked={setLoansChecked}
      />
    </div>
  );
};

export default CustomerTransactions;
